import React from 'react'
import { Box, Stack, Text } from '@chakra-ui/react'
import { TransferDetailsFields, TransferForm } from '@Types'

export interface Props {
  fields?: TransferForm
  cashDirection?: string
}

export const PositionJournalTransferDetails = ({ fields, cashDirection }: Props) => {
  const transferDetails = fields?.transferDetails as TransferDetailsFields
  return (
    <Stack spacing='8'>
      <Stack direction='row' spacing='5'>
        {transferDetails?.transferType?.raw && (
          <Box width={7.5 / 16}>
            <Text>Transfer Type</Text>
            <Text>{transferDetails.transferType.display}</Text>
          </Box>
        )}

        <Box width={7.5 / 16}>
          <Text>Security ID</Text>
          <Text>{transferDetails?.positionJournalDetails?.securityId}</Text>
        </Box>
      </Stack>

      <Stack direction='row' spacing='5'>
        {transferDetails?.accounts?.from && (
          <Box width={7.5 / 16}>
            <Text>From Account</Text>
            <Text>{transferDetails.accounts.from}</Text>
          </Box>
        )}
        <Box width={7.5 / 16}>
          <Text>Quantity</Text>
          <Text>{transferDetails.positionJournalDetails?.quantity}</Text>
        </Box>
      </Stack>

      {transferDetails?.accounts?.to && (
        <Stack direction='row' spacing='5'>
          <Box width={7.5 / 16}>
            <Text>To Account</Text>
            <Text>{transferDetails.accounts.to}</Text>
          </Box>
        </Stack>
      )}

      {fields?.transferDate && (
        <Stack direction='row' spacing='5'>
          <Box width={7.5 / 16}>
            <Text>Transfer Date</Text>
            <Text>{fields?.transferDate}</Text>
          </Box>
        </Stack>
      )}
    </Stack>
  )
}
